module.exports = __webpack_public_path__ + "static/media/MXN.ce404967.svg";